import React from 'react';
import Typography from '../../../base/Typography';
import Colors from '../../../theme/colors';
import { Row, Col } from '../../../base/Grid';

import {
  ContainerStyled,
  IconStyled,
  LinkStyled,
  TypographyHeroConfirmationStyled,
} from './styles';

export const ThankYouModuleComponent = ({
  userName,
  variant,
}) => {
  const hero = variant === 'hero'; // If 'hero' variant
  return (
    <ContainerStyled
      formvariant={variant}
      id='in-page-lead-thank-you-view'>
      <Row align='center'>
        <IconStyled formvariant={variant} />
      </Row>
      <Row align='center'>
        <Col align='center'>
          <TypographyHeroConfirmationStyled
            component='p'
            formvariant={variant}
            variant={hero
              ? 'h2'
              : 'h4'}
            color={Colors.neutral.white}>
            Got it&#33; Thanks, {userName}.
          </TypographyHeroConfirmationStyled>
          {hero && (
            <Typography
              component='p'
              variant='h2'
              color={Colors.neutral.white}
              disableBottomPadding>
              We&#39;re excited to work with you.
            </Typography>
          )}
        </Col>
      </Row>
      {/* FOR EMBEDDED VARIANT (DEFAULT) */}
      {!hero && (
        <Row align='center'>
          <Col
            xsmall={12}
            medium={10}>
            <Typography
              component='p'
              color={Colors.neutral.white}>
              We&#39;re excited to work with you. Your advisor will reach out soon to talk about your goals.
              Until then, check out&nbsp;
              <LinkStyled
                id='in-page-lead-form-guide-on-what-to-expect-link'
                href='/email-landing/prospect/get-the-most-from-your-first-advisor-meeting?utm_source=NMCOM&utm_medium=LandingPage&utm_term=na&utm_campaign=FAFA&utm_content=Let%27s_Get_Ready'
                variant='primary'>
                our guide on what you can expect
              </LinkStyled>
            &nbsp;from your first meeting and what to have handy.
            </Typography>
          </Col>
        </Row>
      )}
    </ContainerStyled>
  );
};

export default ThankYouModuleComponent;
